// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9305) return "static/chunks/9305-477e40fc7c55a629.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1477":"b1a61ce7a7d586b1","3631":"aa220d3c526025d7","8451":"455095dd06d46281","8779":"c7d44973d950f14a"}[chunkId] + ".js";
};